module.exports = __webpack_public_path__ + "static/img/20005 (2).0fcdcfb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20005 (2).webp
// module id = agzY
// module chunks = 14